import { fields } from "@monorepo/utils/src/variables/projectsData/versionCatalogView/fields";

export const currentFilters = (): Record<string, unknown> => ({
  [fields.CREATE_DATE_FROM]: "",
  [fields.CREATE_DATE_TO]: "",
  [fields.STATE]: [],
  [fields.CATALOG]: "",
});
